import { Theme } from '@eversports/react-components/design-tokens/theme'
import Flex from '@eversports/react-components/primitives/Flex'
import RadioButton from '@eversports/react-components/primitives/RadioButton'
import { TableRow } from '@eversports/react-components/primitives/Table'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { ConfirmWithOption } from '../../typings/Product'

import AssignedProductName from './AssignedProductName'
import ProductTableCell from './ProductTableCell'

interface Props {
  product: ConfirmWithOption
}

const useStyles = makeStyles((theme: Theme) => ({
  row: ({ isDisabled }: { isDisabled: boolean }) => ({
    opacity: isDisabled ? 0.5 : 1,
    pointerEvents: isDisabled ? 'none' : 'auto',
    '&:hover': {
      backgroundColor: theme.palette.disabled,
    },
  }),
  radio: {
    paddingLeft: 0,
  },
}))

const AssignedProduct: React.FC<React.PropsWithChildren<Props>> = ({ product }) => {
  const isDisabled = !product.assignedProductValidity.isValid
  const classes = useStyles({ isDisabled })

  return (
    <TableRow className={classes.row}>
      <ProductTableCell>
        <Flex is="label" alignItems="center">
          <RadioButton name="settleWithId" value={product.id} className={classes.radio} />
          <AssignedProductName assignedProduct={product} />
        </Flex>
      </ProductTableCell>
    </TableRow>
  )
}

export default AssignedProduct
